import VueRouter from 'vue-router';
import routes from './routes';

export const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history',
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
